module.exports = __webpack_public_path__ + "static/scale-model-of-charm-city-pedal-mill-in-baltimore-maryland-253159790b553757a90843fa9609051d.png";